import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from 'components/ui/sheet';
import { Heart } from 'lucide-react';
import { DocumentLink, indexedItemKey } from 'domain/documents/schemas/document';
import FavoriteListItem from './FavoriteListItem';
import { useTranslation } from 'react-i18next';

type FavoriteListProps = {
  documents?: DocumentLink[];
  isLoading?: boolean;
};

export default function FavoriteList({ documents }: FavoriteListProps) {
  const { t } = useTranslation('common');
  return (
    <div className="rounded-md hover:bg-gray-100">
      <Sheet>
        <SheetTrigger asChild>
          <div className="text-md group/dropdown-menu-item relative flex cursor-pointer items-center gap-1.5 rounded-md px-1.5 py-1 outline-hidden select-none focus:bg-accent focus:text-accent-foreground **:focus:not-data-[variant=destructive]:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 data-inset:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4">
            <Heart />
            {t('favorites')}
          </div>
        </SheetTrigger>
        <SheetContent side="full" className="data-[side=bottom]:max-h-[50vh] data-[side=top]:max-h-[50vh]">
          <SheetHeader>
            <SheetTitle className="mb-4 font-merriweather text-3xl font-bold text-primary">{t('favorites')}</SheetTitle>
          </SheetHeader>
          <div className="flex flex-col gap-8 overflow-y-auto">
            {documents?.map(document => (
              <FavoriteListItem key={indexedItemKey(document)} document={document} />
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
